<template>
    <div class="container py-5">
      <h2 class="mb-4 text-center text-primary">Dernek Tools</h2>
      <div class="list-group">
  
        <router-link to="/tesekkur" class="list-group-item list-group-item-action">
          🎉 Teşekkür Belgesi Oluştur
        </router-link>
  
        <router-link to="/taziye" class="list-group-item list-group-item-action">
          🕊️ Taziye Mesajı Oluştur
        </router-link>
  
        <router-link to="/duyuru" class="list-group-item list-group-item-action">
          📢 Duyuru Oluştur
        </router-link>
        <router-link to="/vefat" class="list-group-item list-group-item-action">
          📢 Vefat Oluştur
        </router-link>
        <router-link to="/toplanti" class="list-group-item list-group-item-action">
          📢 Toplantı Notları
        </router-link>
  
      </div>
    </div>
  </template>
  